import _extends from '@babel/runtime/helpers/esm/extends';
import React from 'react';
import { PropTypes, describe } from 'react-desc';
import 'react-dates/initialize';
import { SingleDatePickerPhrases } from 'react-dates';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import moment from 'moment';
export { default as DatePickerNavigation } from './components/DatePickerNavigation/DatePickerNavigation.js';
export { default as DatePickerDay } from './components/DatePickerDay/DatePickerDay.js';
import { PickerPropsTypes } from './components/DatePickerPicker/DatePickerPicker.js';
export { Picker as DatePickerPicker, Picker } from './components/DatePickerPicker/DatePickerPicker.js';
export { default as DatePickerDropdown } from './components/DatePickerDropdown.js';
export { default as DatePickerSingleDate } from './components/DatePickerSingleDate/DatePickerSingleDate.js';
export { default as DatePickerHeader } from './components/DatePickerHeader/DatePickerHeader.js';
export { default as DatePickerRange } from './components/DatePickerRange/DatePickerRange.js';
export { default as DatePickerRangeHeader } from './components/DatePickerRangeHeader/DatePickerRangeHeader.js';
export { default as SingleRangeDateSwitcher } from './components/SingleRangeDateSwitcher/SingleRangeDateSwitcher.js';
export { renderMonthElement } from './components/DatePickerRenderMonth/DatePickerRenderMonth.js';
import DSdatePickerImpl from './components/DSDatePickerImpl.js';
export { default as DSDatePickerController } from './components/DatePickerController/DatePickerController.js';
import 'prop-types';
import '@elliemae/ds-icons/ChevronRight';
import '@elliemae/ds-basic/Icon';
import './prop-types-8c5debac.js';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@elliemae/ds-icons/DatePicker';
import '@elliemae/ds-basic/Button';
import '@elliemae/ds-basic/Popper';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@elliemae/ds-date-picker';
import '@elliemae/ds-icons/ChevronLeft';
import '@elliemae/ds-basic/form/DateInputV2';
import '@elliemae/ds-basic/form/InputGroup';
import '@elliemae/ds-basic/form/Checkbox';
import '@elliemae/ds-icons/ChevronDoubleLeft';
import '@elliemae/ds-icons/ChevronDoubleRight';
import '@elliemae/ds-basic/Grid';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@babel/runtime/helpers/esm/defineProperty';
import '@babel/runtime/helpers/esm/toArray';

var DSDatePicker = function DSDatePicker(_ref) {
  var _ref$containerProps = _ref.containerProps,
      containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? '' : _ref$id,
      _ref$appendToBody = _ref.appendToBody,
      appendToBody = _ref$appendToBody === void 0 ? true : _ref$appendToBody,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      date = _ref.date,
      value = _ref.value,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      _ref$hasError = _ref.hasError,
      hasError = _ref$hasError === void 0 ? false : _ref$hasError,
      _ref$screenReaderInpu = _ref.screenReaderInputMessage,
      screenReaderInputMessage = _ref$screenReaderInpu === void 0 ? 'Select date' : _ref$screenReaderInpu,
      _ref$enableOutsideDay = _ref.enableOutsideDays,
      enableOutsideDays = _ref$enableOutsideDay === void 0 ? true : _ref$enableOutsideDay,
      _ref$initialVisibleMo = _ref.initialVisibleMonth,
      _initialVisibleMonth = _ref$initialVisibleMo === void 0 ? moment() : _ref$initialVisibleMo,
      _ref$firstDayOfWeek = _ref.firstDayOfWeek,
      firstDayOfWeek = _ref$firstDayOfWeek === void 0 ? 0 : _ref$firstDayOfWeek,
      _ref$keepOpenOnDateSe = _ref.keepOpenOnDateSelect,
      keepOpenOnDateSelect = _ref$keepOpenOnDateSe === void 0 ? false : _ref$keepOpenOnDateSe,
      _ref$hideKeyboardShor = _ref.hideKeyboardShortcutsPanel,
      hideKeyboardShortcutsPanel = _ref$hideKeyboardShor === void 0 ? true : _ref$hideKeyboardShor,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return null;
  } : _ref$onChange,
      _ref$onDateChange = _ref.onDateChange,
      _onDateChange = _ref$onDateChange === void 0 ? undefined : _ref$onDateChange,
      _ref$onPrevMonthClick = _ref.onPrevMonthClick,
      onPrevMonthClick = _ref$onPrevMonthClick === void 0 ? function () {
    return null;
  } : _ref$onPrevMonthClick,
      _ref$onNextMonthClick = _ref.onNextMonthClick,
      onNextMonthClick = _ref$onNextMonthClick === void 0 ? function () {
    return null;
  } : _ref$onNextMonthClick,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {
    return null;
  } : _ref$onClose,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? function () {
    return null;
  } : _ref$onFocus,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? function () {
    return null;
  } : _ref$onBlur,
      _ref$phrases = _ref.phrases,
      phrases = _ref$phrases === void 0 ? SingleDatePickerPhrases : _ref$phrases,
      _ref$displayFormat = _ref.displayFormat,
      displayFormat = _ref$displayFormat === void 0 ? 'L' : _ref$displayFormat,
      _ref$displayFormatDay = _ref.displayFormatDay,
      displayFormatDay = _ref$displayFormatDay === void 0 ? 'D' : _ref$displayFormatDay,
      _ref$transitionDurati = _ref.transitionDuration,
      transitionDuration = _ref$transitionDurati === void 0 ? 0 : _ref$transitionDurati,
      _ref$verticalSpacing = _ref.verticalSpacing,
      verticalSpacing = _ref$verticalSpacing === void 0 ? 0 : _ref$verticalSpacing,
      _ref$isDayBlocked = _ref.isDayBlocked,
      isDayBlocked = _ref$isDayBlocked === void 0 ? function () {
    return false;
  } : _ref$isDayBlocked,
      _ref$isOutsideRange = _ref.isOutsideRange,
      isOutsideRange = _ref$isOutsideRange === void 0 ? function () {
    return false;
  } : _ref$isOutsideRange,
      _ref$isDayHighlighted = _ref.isDayHighlighted,
      isDayHighlighted = _ref$isDayHighlighted === void 0 ? function () {
    return false;
  } : _ref$isDayHighlighted,
      _ref$numberOfMonths = _ref.numberOfMonths,
      numberOfMonths = _ref$numberOfMonths === void 0 ? 1 : _ref$numberOfMonths,
      _ref$openDirection = _ref.openDirection,
      openDirection = _ref$openDirection === void 0 ? 'down' : _ref$openDirection,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? '' : _ref$tabIndex,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? 'auto' : _ref$zIndex,
      _ref$pickerProps = _ref.pickerProps,
      pickerProps = _ref$pickerProps === void 0 ? {} : _ref$pickerProps,
      _ref$calendarProps = _ref.calendarProps,
      calendarProps = _ref$calendarProps === void 0 ? {} : _ref$calendarProps,
      _ref$autoClear = _ref.autoClear,
      autoClear = _ref$autoClear === void 0 ? false : _ref$autoClear;

  var _convertPropToCssClas = convertPropToCssClassName('datepicker', className, {
    hasError: hasError,
    readOnly: readOnly,
    disabled: disabled,
    id: id
  }),
      cssClassName = _convertPropToCssClas.cssClassName;

  var safeDate = date || value;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cssClassName
  }, containerProps), /*#__PURE__*/React.createElement(DSdatePickerImpl, {
    appendToBody: appendToBody,
    autoClear: autoClear,
    date: safeDate,
    disabled: disabled,
    displayFormat: displayFormat,
    displayFormatDay: displayFormatDay,
    enableOutsideDays: enableOutsideDays,
    firstDayOfWeek: firstDayOfWeek,
    hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
    initialVisibleMonth: function initialVisibleMonth() {
      return _initialVisibleMonth ? moment(_initialVisibleMonth) : moment(safeDate);
    },
    isDayBlocked: isDayBlocked,
    isDayHighlighted: isDayHighlighted,
    isOutsideRange: isOutsideRange === true || isOutsideRange === false ? function () {
      return isOutsideRange;
    } : isOutsideRange,
    keepOpenOnDateSelect: keepOpenOnDateSelect,
    numberOfMonths: numberOfMonths,
    onBlur: onBlur,
    onClose: onClose,
    onChange: onChange,
    onDateChange: function onDateChange() {
      if (_onDateChange) _onDateChange.apply(void 0, arguments);
    },
    onFocus: onFocus,
    onNextMonthClick: onNextMonthClick,
    onPrevMonthClick: onPrevMonthClick,
    openDirection: openDirection,
    phrases: phrases,
    placeholder: placeholder,
    readOnly: readOnly,
    required: required,
    screenReaderInputMessage: screenReaderInputMessage,
    transitionDuration: transitionDuration,
    value: safeDate,
    verticalSpacing: verticalSpacing,
    tabIndex: tabIndex,
    zIndex: zIndex,
    pickerProps: pickerProps,
    calendarProps: calendarProps
  }));
};

var datePickerProps = {
  containerProps: PropTypes.shape({}).description('Set of Properties attached to the main container'),
  id: PropTypes.string.description('components id'),
  appendToBody: PropTypes.bool.description('append component to body or not').defaultValue(true),
  className: PropTypes.string.description('html class attribute'),
  date: PropTypes.instanceOf(Date, moment).description('selected date').defaultValue(undefined),
  value: PropTypes.instanceOf(Date, moment).description('value'),
  placeholder: PropTypes.string.description('input placeholder value'),
  autoClear: PropTypes.bool.description('autoclears the input onblur if the date is not completely set').defaultValue(false),
  disabled: PropTypes.bool.description('disable component or not').defaultValue(false),
  required: PropTypes.bool.description('value is required or not').defaultValue(false),
  readOnly: PropTypes.bool.description('is read only or not').defaultValue(false),
  hasError: PropTypes.bool.description('set error state').defaultValue(false),
  screenReaderInputMessage: PropTypes.string.description('message to anounce by screen reader').defaultValue('select date'),
  enableOutsideDays: PropTypes.bool.description('enable days oustide month or not').defaultValue(true),
  initialVisibleMonth: PropTypes.instanceOf(Date, moment).description('initial month to display'),
  firstDayOfWeek: PropTypes.number.description('first day of week').defaultValue(0),
  keepOpenOnDateSelect: PropTypes.bool.description('keep picker open when a date is selected').defaultValue(false),
  hideKeyboardShortcutsPanel: PropTypes.bool.description('hide keyabord shortcut panel or not').defaultValue(true),
  onChange: PropTypes.func.description("\n      function executed when input changes. This could trigger with invalid dates. It returns a string and a moment\n      if the date is valid.\n    "),
  onDateChange: PropTypes.func.description('function executed when date changes. This doesnt trigger with invalid dates. It returns a moment object'),
  onPrevMonthClick: PropTypes.func.description('function executed when clicking on prev month button'),
  onNextMonthClick: PropTypes.func.description('function executed when clicking on next month button'),
  onBlur: PropTypes.func.description('function executed when component loses focus'),
  onClose: PropTypes.func.description('function executed when component closes'),
  onFocus: PropTypes.func.description('function executed when component gains focus'),
  phrases: PropTypes.shape({
    calendarLabel: PropTypes.string,
    closeDatePicker: PropTypes.string,
    clearDates: PropTypes.string,
    focusStartDate: PropTypes.string,
    jumpToPrevMonth: PropTypes.string,
    jumpToNextMonth: PropTypes.string,
    keyboardShortcuts: PropTypes.string,
    showKeyboardShortcutsPanel: PropTypes.string,
    hideKeyboardShortcutsPanel: PropTypes.string,
    openThisPanel: PropTypes.string,
    enterKey: PropTypes.string,
    leftArrowRightArrow: PropTypes.string,
    upArrowDownArrow: PropTypes.string,
    pageUpPageDown: PropTypes.string,
    homeEnd: PropTypes.string,
    escape: PropTypes.string,
    questionMark: PropTypes.string,
    selectFocusedDate: PropTypes.string,
    moveFocusByOneDay: PropTypes.string,
    moveFocusByOneWeek: PropTypes.string,
    moveFocusByOneMonth: PropTypes.string,
    moveFocustoStartAndEndOfWeek: PropTypes.string,
    returnFocusToInput: PropTypes.string,
    keyboardNavigationInstructions: PropTypes.string,
    chooseAvailableStartDate: PropTypes.func,
    chooseAvailableEndDate: PropTypes.func,
    dateIsUnavailable: PropTypes.func,
    dateIsSelected: PropTypes.func
  }).description('react-dates phrases').defaultValue(SingleDatePickerPhrases),
  displayFormat: PropTypes.string.description('display format').defaultValue('L'),
  displayFormatDay: PropTypes.string.description('display format day').defaultValue('D'),
  transitionDuration: PropTypes.number.description('transition duration').defaultValue(0),
  verticalSpacing: PropTypes.number.description('vertical spacing'),
  isDayBlocked: PropTypes.func.description('function that returns each day and disables desired dates'),
  isOutsideRange: PropTypes.func.description('function that returns each day and disables outisde range dates'),
  isDayHighlighted: PropTypes.func.description('function that returns each day and higlights desired dates'),
  numberOfMonths: PropTypes.number.description('amount of months'),
  openDirection: PropTypes.string.description('open direction of the popup').defaultValue('down'),
  tabIndex: PropTypes.string.description('overrides tab index of the element'),
  zIndex: PropTypes.string.description('overrides z-index of the element'),
  pickerProps: PropTypes.shape(PickerPropsTypes).description('props to be passed to the picker container'),
  calendarProps: PropTypes.shape({
    tabIndex: PropTypes.number
  }).description('props to be passes to the calendar container')
};
DSDatePicker.propTypes = datePickerProps;
var DatePickerWithSchema = describe(DSDatePicker);
DatePickerWithSchema.propTypes = datePickerProps;

export default DSDatePicker;
export { DatePickerWithSchema };
//# sourceMappingURL=DSDatePicker.js.map
